// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3X0JU","col":"styles_col__6lFV5"};